export default __webpack_public_path__ + "static/media/tat_img5.98197df1.webp";